/** Cross-tab data sync — when one tab mutates data, others refetch. */
export const DATA_TYPES = {
  HOSPITALS: 'hospitals',
  DOCTORS: 'doctors',
  SHIFTS: 'shifts',
  GROUP: 'group',
  ALL: 'all',
};

const EVENT_NAME = 'appDataChange';

export function emitDataChange(type = DATA_TYPES.ALL) {
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { type } }));
}

export function onDataChange(handler) {
  const listener = (e) => handler(e.detail?.type || DATA_TYPES.ALL);
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}

export function shouldRefresh(changed, watchList) {
  return watchList.includes(DATA_TYPES.ALL) || watchList.includes(changed) || changed === DATA_TYPES.ALL;
}
